const FIELDS = [
    // --- 4. Berechnung der Umsatzsteuer ---------------------------------------
    {
        kz: '000',
        label: 'Gesamtbetrag der Bemessungsgrundlage für Lieferungen und sonstige Leistungen (ohne Eigenverbrauch) einschließlich Anzahlungen',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
        alwaysShow: true,
        hint: 'Alle steuerbaren Umsätze netto, auch die steuerfreien.',
    },
    {
        kz: '001',
        label: 'zuzüglich Eigenverbrauch (§ 1 Abs 1 Z 2, § 3 Abs 2 und § 3a Abs 1a)',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
    },
    {
        kz: '021',
        label: 'abzüglich Umsätze, für die die Steuerschuld gemäß § 19 Abs 1 zweiter Satz sowie § 19 Abs 1a bis 1e auf den Leistungsempfänger übergegangen ist',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
        hint: 'Reverse-Charge-Ausgangsumsätze im Inland.',
    },
    // Steuerfrei MIT Vorsteuerabzug
    {
        kz: '011',
        label: '§ 6 Abs 1 Z 1 iVm § 7 (Ausfuhrlieferungen)',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
    },
    {
        kz: '012',
        label: '§ 6 Abs 1 Z 1 iVm § 8 (Lohnveredelungen)',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
    },
    {
        kz: '015',
        label: '§ 6 Abs 1 Z 2 bis 6, § 23 Abs 5 (Seeschifffahrt, Luftfahrt, grenzüberschreitende Personenbeförderung, Diplomaten, Reisevorleistungen im Drittlandsgebiet)',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
    },
    {
        kz: '017',
        label: 'Art 6 Abs 1 (innergemeinschaftliche Lieferungen ohne Fahrzeuglieferungen)',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
        hint: 'Muss mit der Zusammenfassenden Meldung übereinstimmen.',
    },
    {
        kz: '018',
        label: 'Art 6 Abs 1, Lieferungen neuer Fahrzeuge an Abnehmer ohne UID-Nummer',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
    },
    // Steuerfrei OHNE Vorsteuerabzug
    {
        kz: '019',
        label: '§ 6 Abs 1 Z 9 lit a (Grundstücksumsätze)',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
    },
    {
        kz: '016',
        label: '§ 6 Abs 1 Z 27 (Kleinunternehmer)',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
    },
    {
        kz: '020',
        label: '§ 6 Abs 1 Z … (übrige steuerfreie Umsätze ohne Vorsteuerabzug)',
        section: 'lieferungen',
        type: 'base',
        effect: 'memo',
    },
    // Steuersätze
    {
        kz: '022',
        label: '20 % Normalsteuersatz',
        section: 'steuersaetze',
        type: 'base',
        rate: 0.2,
        effect: 'owed',
        alwaysShow: true,
    },
    {
        kz: '029',
        label: '10 % ermäßigter Steuersatz',
        section: 'steuersaetze',
        type: 'base',
        rate: 0.1,
        effect: 'owed',
        alwaysShow: true,
    },
    {
        kz: '006',
        label: '13 % ermäßigter Steuersatz',
        section: 'steuersaetze',
        type: 'base',
        rate: 0.13,
        effect: 'owed',
    },
    {
        kz: '124',
        label: '4,9 % ermäßigter Steuersatz für Nahrungsmittel (§ 10 Abs 1a iVm Anlage 3)',
        section: 'steuersaetze',
        type: 'base',
        rate: 0.049,
        effect: 'owed',
    },
    {
        kz: '037',
        label: '19 % für Jungholz und Mittelberg',
        section: 'steuersaetze',
        type: 'base',
        rate: 0.19,
        effect: 'owed',
    },
    {
        kz: '052',
        label: '10 % Zusatzsteuer für pauschalierte land- und forstwirtschaftliche Betriebe',
        section: 'steuersaetze',
        type: 'base',
        rate: 0.1,
        effect: 'owed',
    },
    {
        kz: '007',
        label: '7 % Zusatzsteuer für pauschalierte land- und forstwirtschaftliche Betriebe',
        section: 'steuersaetze',
        type: 'base',
        rate: 0.07,
        effect: 'owed',
    },
    // Weiters zu versteuern
    {
        kz: '056',
        label: 'Steuerschuld gemäß § 11 Abs 12 und 14, § 16 Abs 2 sowie gemäß Art 7 Abs 4',
        section: 'sonstige',
        type: 'tax',
        effect: 'owed',
        hint: 'Steuerschuld kraft Rechnungslegung.',
    },
    {
        kz: '057',
        label: 'Steuerschuld gemäß § 19 Abs 1 zweiter Satz, § 19 Abs 1c, 1e sowie gemäß Art 25 Abs 5',
        section: 'reverse_charge',
        type: 'tax',
        effect: 'owed',
        hint: 'Leistungsbezug von ausländischen Unternehmern — Gegenposten ist KZ 066.',
    },
    {
        kz: '048',
        label: 'Steuerschuld gemäß § 19 Abs 1a (Bauleistungen)',
        section: 'reverse_charge',
        type: 'tax',
        effect: 'owed',
    },
    {
        kz: '044',
        label: 'Steuerschuld gemäß § 19 Abs 1b (Sicherungseigentum, Vorbehaltseigentum und Grundstücke im Zwangsversteigerungsverfahren)',
        section: 'reverse_charge',
        type: 'tax',
        effect: 'owed',
    },
    {
        kz: '032',
        label: 'Steuerschuld gemäß § 19 Abs 1d (Schrott und Abfallstoffe, Videospielkonsolen, Laptops, Tablet-Computer, Gas und Elektrizität, Metalle, Anlagegold)',
        section: 'reverse_charge',
        type: 'tax',
        effect: 'owed',
    },
    // Innergemeinschaftliche Erwerbe
    {
        kz: '070',
        label: 'Gesamtbetrag der Bemessungsgrundlagen für innergemeinschaftliche Erwerbe',
        section: 'erwerbe',
        type: 'base',
        effect: 'memo',
    },
    {
        kz: '071',
        label: 'Davon steuerfrei gemäß Art 6 Abs 2',
        section: 'erwerbe',
        type: 'base',
        effect: 'memo',
    },
    {
        kz: '072',
        label: '20 % Normalsteuersatz',
        section: 'erwerbe',
        type: 'base',
        rate: 0.2,
        effect: 'owed',
        hint: 'Erwerbsteuer — Gegenposten ist KZ 065.',
    },
    {
        kz: '073',
        label: '10 % ermäßigter Steuersatz',
        section: 'erwerbe',
        type: 'base',
        rate: 0.1,
        effect: 'owed',
    },
    {
        kz: '008',
        label: '13 % ermäßigter Steuersatz',
        section: 'erwerbe',
        type: 'base',
        rate: 0.13,
        effect: 'owed',
    },
    {
        kz: '125',
        label: '4,9 % ermäßigter Steuersatz für Nahrungsmittel (§ 10 Abs 1a iVm Anlage 3)',
        section: 'erwerbe',
        type: 'base',
        rate: 0.049,
        effect: 'owed',
    },
    {
        kz: '088',
        label: '19 % für Jungholz und Mittelberg',
        section: 'erwerbe',
        type: 'base',
        rate: 0.19,
        effect: 'owed',
    },
    {
        kz: '076',
        label: 'Erwerbe gemäß Art 3 Abs 8 zweiter Satz, die im Mitgliedstaat des Bestimmungslandes besteuert worden sind',
        section: 'erwerbe',
        type: 'base',
        effect: 'memo',
    },
    {
        kz: '077',
        label: 'Erwerbe gemäß Art 3 Abs 8 zweiter Satz, die gemäß Art 25 Abs 2 im Inland als besteuert gelten',
        section: 'erwerbe',
        type: 'base',
        effect: 'memo',
        hint: 'Dreiecksgeschäfte.',
    },
    // --- 5. Berechnung der abziehbaren Vorsteuer ------------------------------
    {
        kz: '060',
        label: 'Gesamtbetrag der Vorsteuern (ohne die nachstehend gesondert anzuführenden Beträge)',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
        alwaysShow: true,
    },
    {
        kz: '061',
        label: 'Vorsteuern betreffend die entrichtete Einfuhrumsatzsteuer (§ 12 Abs 1 Z 2 lit a)',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
    },
    {
        kz: '083',
        label: 'Vorsteuern betreffend die geschuldete, auf dem Abgabenkonto verbuchte Einfuhrumsatzsteuer (§ 12 Abs 1 Z 2 lit b)',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
    },
    {
        kz: '065',
        label: 'Vorsteuern aus dem innergemeinschaftlichen Erwerb',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
    },
    {
        kz: '066',
        label: 'Vorsteuern betreffend die Steuerschuld gemäß § 19 Abs 1 zweiter Satz, § 19 Abs 1c, 1e sowie Art 25 Abs 5',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
    },
    {
        kz: '082',
        label: 'Vorsteuern betreffend die Steuerschuld gemäß § 19 Abs 1a (Bauleistungen)',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
    },
    {
        kz: '087',
        label: 'Vorsteuern betreffend die Steuerschuld gemäß § 19 Abs 1b',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
    },
    {
        kz: '089',
        label: 'Vorsteuern betreffend die Steuerschuld gemäß § 19 Abs 1d',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
    },
    {
        kz: '064',
        label: 'Vorsteuern für innergemeinschaftliche Lieferungen neuer Fahrzeuge von Fahrzeuglieferern gemäß Art 2',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
    },
    {
        kz: '062',
        label: 'Davon nicht abzugsfähig gemäß § 12 Abs 3 iVm Abs 4 und 5',
        section: 'vorsteuer',
        type: 'input',
        effect: 'owed',
        hint: 'Kürzt die Vorsteuer, erhöht daher die Zahllast.',
    },
    {
        kz: '063',
        label: 'Berichtigung gemäß § 12 Abs 10 und 11',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
    },
    {
        kz: '067',
        label: 'Berichtigung gemäß § 16',
        section: 'vorsteuer',
        type: 'input',
        effect: 'deductible',
    },
    // --- 6. Sonstige Berichtigungen -------------------------------------------
    {
        kz: '090',
        label: 'Sonstige Berichtigungen',
        section: 'sonstige',
        type: 'tax',
        effect: 'owed',
    },
    {
        kz: '095',
        label: 'Vorauszahlung (Zahllast) bzw. Überschuss (Gutschrift)',
        section: 'sonstige',
        type: 'tax',
        effect: 'memo',
        alwaysShow: true,
    },
];
/** Kennzahlen that make up line 4.4 (SUMME). */
export const UVA_SUM_ADD = ['000', '001'];
export const UVA_SUM_SUBTRACT = ['021'];
/** Kennzahlen deducted on the way from 4.4 to 4.13 (steuerpflichtige Umsätze). */
export const UVA_EXEMPT_KZ = ['011', '012', '015', '017', '018', '019', '016', '020'];
/** Kennzahlen summing to line 5.13 (Gesamtbetrag der abziehbaren Vorsteuer). */
export const UVA_INPUT_VAT_KZ = [
    '060',
    '061',
    '083',
    '065',
    '066',
    '082',
    '087',
    '089',
    '064',
    '063',
    '067',
];
/**
 * Kennzahlen the form only grew later, with the first year they appear on it.
 * Older years must not offer them — a 2025 UVA has no 4,9 % line.
 */
const KZ_FROM_YEAR = {
    // § 10 Abs 1a UStG iVm Anlage 3, BGBl I 37/2026, Umsätze ab 1.7.2026.
    '124': 2026,
    '125': 2026,
};
export function uvaForm(year) {
    return {
        formId: 'U30',
        fields: FIELDS.filter((field) => year >= (KZ_FROM_YEAR[field.kz] ?? 0)),
        resultKz: '095',
        totalBaseKz: '000',
    };
}
//# sourceMappingURL=uva.js.map